import React from 'react';
import { useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
import './dashboard.scss';

const MONTH_LABELS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December',
];

const OffersChart = ({ className, barThickness }) => {
  const offerStats = useSelector((s) => s?.adminReducer?.dashboardOfferStats);

  // Labels drive the X-axis — fall back to 12 months if not yet loaded
  const labels = Array.isArray(offerStats?.labels) && offerStats.labels.length
    ? offerStats.labels
    : MONTH_LABELS;

  const detail = (offerStats?.detail && typeof offerStats.detail === 'object')
    ? offerStats.detail
    : {};

  // Primary series: Offers Created per bucket
  const createdData = labels.map((l) => detail[l]?.created ?? 0);


  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      fontFamily: 'Poppins, sans-serif',
    },
    colors: ['rgba(0, 173, 239, 1)'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20px',
        borderRadius: 3,
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: labels,
      labels: {
        style: { fontSize: '11px', fontFamily: 'Poppins, sans-serif', colors: 'rgba(148,148,148,1)' },
        // No formatter — show labels exactly as returned by backend ("Jul 1–7", "Monday", "January" etc.)
        rotate: labels.length > 6 ? -30 : 0,
        rotateAlways: false,
        hideOverlappingLabels: true,
      },
      axisBorder: { color: 'rgba(148,148,148,1)' },
    },
    yaxis: {
      labels: {
        style: { fontSize: '11px', fontFamily: 'Poppins, sans-serif', colors: 'rgba(148,148,148,1)' },
      },
    },
    grid: {
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: false } },
    },
    legend: { show: false },
    tooltip: {
      custom: ({ dataPointIndex }) => {
        const label = labels[dataPointIndex] || '';
        const d = detail[label] || {};
        const views  = Number(d.views)  || 0;
        const clicks = Number(d.clicks) || 0;
        const ctr    = views > 0 ? Math.min(100, Math.round((clicks / views) * 100)) : 0;

        return `
          <div style="
            padding: 10px 13px;
            background: #fff;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.10);
            font-family: Poppins, sans-serif;
            font-size: 12px;
            min-width: 165px;
          ">
            <div style="font-weight:600; margin-bottom:7px; color:#111; border-bottom:1px solid #f0f0f0; padding-bottom:5px;">
              ${label}
            </div>
            <div style="display:flex; justify-content:space-between; margin-bottom:3px;">
              <span style="color:#6b7280;">New Offers</span>
              <span style="font-weight:600; color:#00ADEF;">${Number(d.created) || 0}</span>
            </div>
            <div style="display:flex; justify-content:space-between; margin-bottom:3px;">
              <span style="color:#6b7280;">Active</span>
              <span style="font-weight:600; color:#22c55e;">${Number(d.active) || 0}</span>
            </div>
            <div style="display:flex; justify-content:space-between; margin-bottom:3px;">
              <span style="color:#6b7280;">Expired</span>
              <span style="font-weight:600; color:#f59e0b;">${Number(d.expired) || 0}</span>
            </div>
            <div style="display:flex; justify-content:space-between; margin-bottom:3px;">
              <span style="color:#6b7280;">Redeemed</span>
              <span style="font-weight:600; color:#8b5cf6;">${Number(d.redeemed) || 0}</span>
            </div>
            <div style="display:flex; justify-content:space-between; margin-bottom:3px;">
              <span style="color:#6b7280;">Views</span>
              <span style="font-weight:600; color:#00ADEF;">${views}</span>
            </div>
            <div style="display:flex; justify-content:space-between;">
              <span style="color:#6b7280;">CTR</span>
              <span style="font-weight:600; color:#00ADEF;">${ctr}%</span>
            </div>
          </div>
        `;
      },
    },
  };

  const series = [
    {
      name: 'Offers Created',
      data: createdData,
    },
  ];

  return (
    <div className={className} style={{ width: '100%' }}>
      <ReactApexChart
        key={labels.join(',')}
        options={chartOptions}
        series={series}
        type="bar"
        height={280}
      />
    </div>
  );
};

export default OffersChart;


